// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n.el-table[data-v-1a02fd0a] th {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
